import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';

const VideoModal = ({ videoList = [], videoIdToShow = null, onClose = () => {} }) => {
  const [selectedVideo, setSelectedVideo] = useState(null);

  useEffect(() => {
    if (videoIdToShow) {
      const found = videoList.find(v => v.id === videoIdToShow);
      setSelectedVideo(found || null);
    } else {
      setSelectedVideo(null);
    }
  }, [videoIdToShow, videoList]);

  if (!selectedVideo) return null;

  return (
    <Modal
      style={{ zIndex: 9002 }}
      show={!!selectedVideo}
      onHide={() => {
        setSelectedVideo(null);
        onClose(); // notify parent to reset videoId
      }}
      centered
      size="lg"
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header className="model-header-tutorial" closeButton>
        <Modal.Title>{selectedVideo.title || 'Watch Tutorial'}</Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ padding: 0 }}>
        <div
          style={{
            position: 'relative',
            width: '100%',
            paddingTop: '56.25%',
          }}
        >
          <iframe
            src={selectedVideo.url}
            title={selectedVideo.title}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              border: 'none',
            }}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default VideoModal;
